import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ serviceItem }) => (
    <>
      <DateTime value={serviceItem.date} /> &middot; {serviceItem.invoiceItem?.name} &middot;{' '}
      <Currency value={serviceItem.fee} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Additional Services"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .serviceItems()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected additional service' : `the ${ids.length} selected additional services`
      }. Invoiced items will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
